<app-header></app-header>
<app-hero-slider></app-hero-slider>
<div #animContainer>
<div id="about" class="three-about-area five-about-area pb-70">

    <div class="container-fluid">
        <div class="row align-items-center">
           

            <div class="col-lg-6">
                <div class="about-content" >
                    <div class="one-section-title three-section-title" >
                        <span class="sub-title">Who We Are</span>
                        <h2 class="">We are Specialists in the field of Landscaping.</h2>
                    </div>

                    <div class="about-mission">


                        <div class="tab-content">
                            <div class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab-two" class="">
                                <p>Ginko Nursery was established in 2017 with a vision to provide top quality and
                                    reliable landscaping services to clients from all sectors at competitive prices. Our
                                    services include design-and-build and maintenance.</p>
                                <p>At Ginko, we aim to always provide our clients guaranteed satisfaction. Our team of
                                    dedicated professionals and subject matter experts with more than 10 years of
                                    experience in horticulture and project management, go beyond
                                    merely meeting requirements.</p>

                                <p>
                                    <span style="font-family:'darling';font-size:30px;vertical-align:middle;">Leaf it to
                                        us</span> , as we say, for your success!
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

             <div class="col-lg-6">
                <div class="about-img anim-it">
                    <img src="assets/img/about1.jpg" alt="About">
                    <!-- <img src="assets/img/leaf1.png" alt="About"> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div id="services" class="four-expect-area pt-100 pb-70">
    <div class="container-fluid" style="position:relative;">
        <div class="one-section-title three-section-title">
            <span class="sub-title">What We Do</span>
            <h2 class="">Our Specialization</h2>
        </div>

        <div class="row">
            <div class="col-sm-6 col-lg-4">
                <div class="expect-item service-box" [routerLink]="['/designandbuild']">
                    <div class="expect-icon">
                        <img src="../../../assets/img/planting.png" width="44px">
                        <h3>Design and Build</h3>
                    </div>
                    
                    <p>
                        Transform your outdoor space into a beautiful and landscape with our professional design and solutions.
                    </p>
                    <span class="viewmore">Learn more 
                        <img src="../../../assets/img/right-up.png" alt="">
                    </span>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="expect-item service-box" [routerLink]="['/implementation']">
                    <div class="expect-icon">
                        <img src="../../../assets/img/lawn-mower.png" width="44px">
                         <h3>Implementation</h3>
                    </div>
                   
                    <p>
                        We bring your landscape design to life with expert implementation — from groundwork to the final finishing touches. 
                    </p>
                    <span class="viewmore">Learn more 
                        <img src="../../../assets/img/right-up.png" alt="">
                    </span>
                </div>
            </div>

            <div class="col-sm-6 col-lg-4">
                <div class="expect-item service-box" [routerLink]="['/care&maintenence']">
                    <div class="expect-icon" style="margin-bottom: 17px;">
                        <img src="../../../assets/img/landscape.png" width="44px">
                        <h3>Care and Maintenance</h3>
                    </div>
                    
                    <p>Keep your landscape looking fresh and beautiful all year round with our professional care and maintenance.</p>
                    <span class="viewmore">Learn more 
                        <img src="../../../assets/img/right-up.png" alt="">
                    </span>
                </div>
            </div>
        </div>

       
    </div>
</div>

<!-- services test -->
 <div class="four-expect-area pt-100 pb-70">
    <div class="container-fluid">
        <div class="row">

        </div>
    </div>
 </div>
 <!-- end service test -->

<div class="one-among-area two-among-area pt-100 pb-70">
    <div class="container-fluid">
        <div class="one-section-title">
            <span class="sub-title">What we have done</span>

            <div>
                <h2 tooltip="This is to protect the privacy of our clients who do not wish to disclose
             any photo of their projects of private residence." flow="down">Selected Projects (Only)</h2>
            </div>


        </div>
        <div class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let project of projects | slice:0:9"
                [routerLink]="['/' + project.category + '/' + project.title]">
                <app-projects [project]="project"></app-projects>
            </div>
        </div>

        <div class="row">
            <p (click)="navigate('projects')" class="text-center" style="cursor: pointer;
            font-size: 18px;
            font-weight: 600;"><img src="../../../assets/img/leaf.png" width="30px;"
                    style="margin-top:-10px;margin-right: 13px;">See All Projects</p>
        </div>
    </div>
</div>



<div class="one-counter-area three-counter-area pt-100 pb-100">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-sm-12 col-lg-12">
                <div class="counter-item">
                    <h4 style="margin-bottom:25px;">Non-Obligatory Survey / Quote</h4>
                    <div class="banner-btn">
                        <a class="cmn-banner-btn" (click)="navigate('contactus')" style="cursor:pointer;"><i
                                class='bx bx-phone-call'></i> Contact Us</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<section class="two-lover-area pt-100 pb-70" id="testimonial">
    <div class="container-fluid">
        <div class="one-section-title" style="margin-bottom:0;">
            <span class="sub-title">Customer Feedbacks</span>
            <h2 class="mb-4">Our Testimonials</h2>
        </div>

        <div class="four-step-slider owl-theme owl-carousel">

            <div class="step-item">
                <div class="lover-item">
                    <ul class="align-items-center">
                        
                        <li>
                            <div class="lover-content ">
                                <h3>Client Name 1</h3>
                                
                                <p class="text-justify">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Nesciunt iusto nostrum quibusdam dolores consectetur voluptates beatae
                                </p>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="step-item">
                <div class="lover-item">
                    <ul class="align-items-center">
                        <li>
                            <div class="lover-content">
                                <h3>Client Name 2</h3>
                                <p class="text-justify">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Nesciunt iusto nostrum quibusdam dolores consectetur voluptates beatae
                                </p>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>


            <div class="step-item">
                <div class="lover-item">
                    <ul class="align-items-center">
                        <li>
                            <div class="lover-content">
                                <h3>Client Name 3</h3>
                                <p class="text-justify">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Nesciunt iusto nostrum quibusdam dolores consectetur voluptates beatae
                                </p>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="step-item">
                <div class="lover-item">
                    <ul class="align-items-center">
                        <li>
                            <div class="lover-content">
                                <h3>Client Name 3</h3>
                                <p class="text-justify">Lorem ipsum dolor sit amet consectetur adipisicing elit.
                                    Nesciunt iusto nostrum quibusdam dolores consectetur voluptates beatae
                                </p>

                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<div class="footer-sub pt-100 pb-100">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-sm-7 col-lg-7">
                <div class="counter-item text-center">
                    <h4 style="margin-bottom:25px;">READY TO TRANSFORM <BR/>YOUR GARDEN</h4>
                    <div class="banner-btn">
                        <a class="cmn-banner-btn" (click)="navigate('contactus')" style="cursor:pointer;"><i
                                class='bx bx-phone-call'></i> Contact Us</a>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
</div>
<app-footer></app-footer>